// extracted by mini-css-extract-plugin
export default {"tableHeader":"THeadContent_tableHeader__vHL8Y","sortIcon":"THeadContent_sortIcon__+JZUW","sorted":"THeadContent_sorted__9Gfa5"};